export default defineNuxtRouteMiddleware(() => {
  const { routeData } = useCustomRouter()
  routeData.value = null
})
